<template>
  <div class="grid-container navBar">
    <router-link class="navBar-image-container" :to="{ name: 'home' }">
      <img class="image-fit" :src="BlocodeLogo"/>
    </router-link>
    <div class="navBar-links">
      <router-link v-if="!isHome" :to="{ name: 'lessons' }">Lessons</router-link>
      <router-link v-if="!isHome" :to="{ name: 'listings' }">Tasklist</router-link>
      <router-link v-if="!isHome" :to="{ name: 'sandbox' }">Sandbox</router-link>
      <button v-if="hasNotLogin" class="btn btn--light-blue m-0" @click="toggleLoginFlyout">
        <span>Masuk</span>
        <i class="fas fa-angle-down ml-1"/>
      </button>
      <span v-else>
        <button class="btn btn--blue m-0" @click="toggleAccountFlyout">
          <i class="fas fa-user-circle mr-1"/>
          <b>{{userDataStore.username}}</b>
          <i class="fas fa-angle-down ml-1 transition" :class="{'rotate-180': accountFlyoutOpen}"/>
        </button>
      </span>
    </div>
    <transition name="slide-top">
      <div class="flyout" v-if="loginFlyoutOpen" v-on-clickaway="toggleLoginFlyout">
        <transition mode="out-in" name="fade">
          <div key="login" class="flex-column" v-if="!registering">
            <p class="gray">Masuk untuk menyimpan <i>progress</i> dan pencapaian kamu.</p>
            <label>Nama pengguna</label>
            <input name="username" v-model="userData.username">
            <label>Kata sandi</label>
            <input name="password" type="password" v-model="userData.password">
            <div v-if="registering">
              <label>Masukkan ulang kata sandi</label>
              <input name="password" type="password">
            </div>
            <button class="btn btn--blue my-1" v-if="!registering" @click="logIn">Masuk</button>
            <button class="btn btn--blue my-1" v-else>Daftar</button>
            <hr/>
            <button class="btn btn--blue my-1" @click="registering = true" v-if="!registering">Daftar Akun Baru</button>
          </div>
          <div key="register" class="flex-column" v-else>
            <p class="gray">Daftarkan akun baru dan mulailah berjelajah!</p>
            <label>Nama pengguna</label>
            <input name="username" v-model="userData.username">
            <label>Kata sandi</label>
            <input name="password" type="password" v-model="userData.password">
            <label>Masukkan ulang kata sandi</label>
            <input name="password" type="password" v-model="userData.retypePassword">
            <button class="btn btn--blue my-1" @click="logIn">Daftar</button>
            <hr/>
            <button class="btn my-1" @click="registering = false">Batal</button>
          </div>
        </transition>
      </div>
    </transition>
    <transition name="slide-top">
      <div class="flyout-wide" v-if="accountFlyoutOpen" v-on-clickaway="toggleAccountFlyout">
        <user-bar/>
        <router-link :to="{ name: 'profile' }" v-if="$route.name !== 'profile'" class="btn btn--blue my-1">
          Buka Profile
        </router-link>
        <router-link :to="{ name: 'market' }" v-if="$route.name !== 'market'" class="btn m-0 mb-1" :class="{'my-1': $route.name === 'profile'}">
          <div class="flex position-relative">
            <span class="w-100">Buka Market</span>
            <span class="zenny-counter"><i class="fas fa-coins"></i> {{$store.getters['userStore/getZenny']}}</span>
          </div>
        </router-link>
        <hr/>
        <div class="mini-quest">
          <div class="flex space-between align-items-center cursor-pointer" @click="userDataStore.isMiniQuestOpen = !userDataStore.isMiniQuestOpen">
            <small class="bold">Mini-quest</small>
            <button class="awkward-button-class-name">
              <i class="fas fa-angle-down" v-if="!userDataStore.isMiniQuestOpen"/>
              <i class="fas fa-angle-up" v-else/>
            </button>
          </div>
          <div v-if="userDataStore.isMiniQuestOpen">
            <div class="mini-quest-item" :class="{'opacity-quarter': item.acquired}" v-for="item in userDataStore.miniQuests" :key="item.id">
              <div>
                {{item.description}}
              </div>
              <div v-if="!item.acquired">
                <i class="fas fa-coins"></i> <b>+{{item.reward}}</b>
              </div>
              <div v-else>
                <i class="fas fa-tick"></i> <b>Selesai</b>
              </div>
            </div>
          </div>
        </div>
        <hr/>
        <div class="mini-quest">
          <div class="flex space-between align-items-center cursor-pointer" @click="userDataStore.isSettingsOpen = !userDataStore.isSettingsOpen">
            <small class="bold">Pengaturan</small>
            <button class="awkward-button-class-name">
              <i class="fas fa-angle-down" v-if="!userDataStore.isSettingsOpen"/>
              <i class="fas fa-angle-up" v-else/>
            </button>
          </div>
          <div class="cursor-pointer" v-if="userDataStore.isSettingsOpen" @click="$store.commit('userStore/toggleDarkMode')">
            <div class="mini-quest-item">
              <div>
                Mode gelap
              </div>
              <div class="flex">
                <b class="m-icon-right" v-if="userDataStore.darkMode">Aktif</b>
                <b class="m-icon-right" v-else>Nonaktif</b>
                <div class="tick-container">
                  <div class="tick" v-if="userDataStore.darkMode">
                    <i class="fas fa-check"></i>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <hr/>
        <button class="btn btn--red m-0" @click="logOut">
          Keluar
        </button>
      </div>
    </transition>
  </div>
</template>

<script>
  import { mixin as clickaway } from 'vue-clickaway'
  import BlocodeLogo from '@/assets/BlocodeLogo.png'
  import UserBar from '@/components/UserBar/UserBar'

  export default {
    name: 'navBar',
    mixins: [ clickaway ],
    components: {
      UserBar
    },
    data() {
      return {
        BlocodeLogo,
        loginFlyoutOpen: false,
        accountFlyoutOpen: false,
        registering: false,
        userData: {
          username: '',
          password: '',
          retypePassword: ''
        },
      }
    },
    computed: {
      userDataStore() {
        return this.$store.state.userStore
      },
      hasNotLogin() {
        return this.$store.getters['userStore/hasNotLogin']
      },
      isHome() {
        return this.$route.name === 'home'
      },
    },
    methods: {
      toggleLoginFlyout() {
        if (this.loginFlyoutOpen) {
          this.loginFlyoutOpen = false
          this.registering = false
        } else this.loginFlyoutOpen = true
      },
      toggleAccountFlyout() {
        this.accountFlyoutOpen = !this.accountFlyoutOpen
      },
      logIn() {
        setTimeout(() => {
          this.$store.commit('userStore/setCredential', {
            username: this.userData.username,
            authKey: 'aiueo'
          })
          this.toggleLoginFlyout()
        }, 500)
      },
      logOut() {
        this.$store.dispatch('userStore/logOut')
        this.toggleAccountFlyout()
      }
    }
  }
</script>

<style lang="scss" scoped>
  @import "src/styles/colors";

  .navBar {
    position: sticky;
    top: 0;
    padding: 1rem;
    display: flex;
    justify-content: space-between;
    z-index: 1000;
    background: linear-gradient(white 0%, rgba(white, 0.8) 60%, rgba(white, 0) 100%);
  }

  .navBar-image-container {
    height: 40px;
  }

  .navBar-links {
    a {
      margin-right: 2rem;
      font-weight: 500;
      color: $demi-gray;
      border-bottom: 2px rgba($demi-gray, 0) solid;
      transition: all 0.1s;
    }

    a:hover {
      color: $dark-gray;
      border-bottom: 2px;
      border-bottom: 2px $dark-gray solid;
    }

    a.router-link-active {
      pointer-events: none;
      font-weight: bold;
      color: $dark-gray;
    }
  }

  .flyout, .flyout-wide {
    position: absolute;
    top: 4rem;
    right: 1rem;
    padding: 1rem;
    display: flex;
    flex-direction: column;
    max-height: calc(100vh - 7rem);
    overflow-y: auto;

    p {
      font-size: 0.9rem;
    }
  }

  .flyout {
    width: 250px;
  }

  .flyout-wide {
    width: 300px;
  }

  .mini-quest-item {
    display: flex;
    justify-content: space-between;
    border-radius: 10px;
    padding: 0.5rem;
    margin-top: 0.5rem;
    font-size: smaller;
    background-color: rgba(black, 0.05);
  }

  .dark-mode {
    .mini-quest-item {
      background-color: rgba(black, 0.1);
    }
  }

  .tick-container {
    position: relative;
    display: inline-block;
    height: 1rem;
    width: 1rem;
    border: rgba(black, 0.5) 2px solid;
    border-radius: 3px;
    box-sizing: border-box;

    .tick {
      position: absolute;
      top: -4px;
      left: 0;
      font-size: 1rem;
    }
  }

  .zenny-counter {
    flex-shrink: 0;
    padding: 0 0.5rem;
    background-color: rgba(black, 0.3);
    color: rgba(white, 0.7);
    border-radius: 5px;
    box-shadow: inset 0 3px 0 0 #252f31;
    text-shadow: 0 -1px 0 #252f31;
  }

  .awkward-button-class-name {
    border-radius: 10px;
  }

  .opacity-quarter {
    opacity: 0.25;
  }

  .dark-mode {
    .navBar {
      background: linear-gradient($dark-mode-back-primary 0%, rgba($dark-mode-back-primary, 0.8) 60%, rgba($dark-mode-back-primary, 0) 100%);
    }

    .navBar-links {
      a {
        color: $demi-gray;
        border-bottom: 2px rgba($demi-gray, 0) solid;
      }

      a:hover {
        color: $light-gray;
        border-bottom: 2px $light-gray solid;
      }

      a.router-link-active {
        color: white;
      }
    }

    .tick-container {
      border-color: rgba(white, 0.5);
    }
  }
</style>
